<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h2 class="title_mo">Danh sách liên hệ</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search search_css" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>

          <!-- Updaste 27/8 -->
          <div class="form-group">
            <Select2
              v-model="filters.moId"
              :options="moOptions"
              :settings="moSettings"
              placeholder="Tìm kiểm merchant owner"
              @change="onChangeMo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.maId"
              :options="maOptions"
              :settings="maSettings"
              placeholder="Tìm kiếm merchant account"
              @change="onChangeMa"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.storeId"
              :options="storeOptions"
              :settings="storeSettings"
              placeholder="Tìm kiếm cửa hàng"
            />
          </div>
          <!-- end Updaste 27/8 -->

          <div class="form-group">
            <Select2 v-model="filters.status" :options="listStatus" placeholder="Trạng thái" />
          </div>
          <div class="form-group form-group-action search_css">
            <button
              @click.prevent="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <button type="button" class="pt-2 mr-2 btn btn-info hc-37" @click="createContact">
              Thêm
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCountCheck :totals="totalCount" :data="totals"></TotalCountCheck>
              </div>
            </div>
            <b-table
              bordered
              hover
              head-variant="light"
              fixed
              show-empty
              responsive
              sticky-header
              :items="dataTable"
              :fields="fields"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #cell(mobile)="{ value }">
                {{ value | encryptPhone }}
              </template>

              <template #cell(index)="{ index }">
                {{
                  pagination.page > 1
                    ? index + 1 + pagination.limit * (pagination.page - 1)
                    : index + 1
                }}
              </template>

              <template #cell(owner)="{ item }">
                <div v-if="item.moContacts && item.moContacts.length > 0" class="contact_owner">
                  <span class="text-muted">MO:</span>
                  <span v-for="(moRoles, index) in item.moContacts" :key="moRoles.contactId">
                    {{ index > 0 ? ', ' : '' }}
                    {{ moRoles.name
                    }}{{ `${moRoles.role ? ' - ' + getRoleNameMo(moRoles.role) : ''}` }}
                  </span>
                </div>
                <div v-if="item.maContacts && item.maContacts.length > 0" class="contact_owner">
                  <span class="text-muted">MA:</span>
                  <span v-for="(maRoles, index) in item.maContacts" :key="maRoles.contactId">
                    {{ index > 0 ? ', ' : '' }}
                    {{ maRoles.name
                    }}{{ `${maRoles.role ? ' - ' + getRoleNameMa(maRoles.role) : ''}` }}
                  </span>
                </div>
                <div
                  v-if="item.storeContacts && item.storeContacts.length > 0"
                  class="contact_owner"
                >
                  <div v-for="storeRoles in item.storeContacts" :key="storeRoles.contactId">
                    <div>
                      <span class="text-muted">Cửa hàng:</span>
                      {{ storeRoles.name }}
                      <span v-if="storeRoles.role">
                        - {{ getRoleNameStore(storeRoles.role) }}
                      </span>
                    </div>
                    <div v-if="storeRoles?.address">
                      <span class="text-muted">Địa chỉ:</span> {{ storeRoles?.address }}
                    </div>
                  </div>
                </div>
              </template>

              <template #cell(tele_info)="{ item }">
                <div v-if="item.name"><span class="text-muted">Tên:</span> {{ item.name }}</div>
                <div v-if="item.mobile">
                  <span class="text-muted">Mobile:</span>
                  <span v-b-tooltip.hover :title="item.mobile">{{
                    item.mobile | encryptPhone
                  }}</span>
                </div>
                <div v-if="item.email"><span class="text-muted">Email:</span> {{ item.email }}</div>
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center" v-if="item.status || item.status != 'null'">
                  <span :class="`badge ${getStatusClass(item.status)}`">{{
                    getStatusName(item.status)
                  }}</span>
                </div>
              </template>

              <template #cell(time)="{ item }">
                <div v-if="item.createdDate" class="nowrap contact_owner">
                  <div><span class="text-muted">Tạo:</span> {{ formatDate(item.createdDate) }}</div>
                  <div v-if="item.createdByName">
                    <span class="text-muted">Bởi:</span> {{ item.createdByName }}
                  </div>
                </div>
                <div v-if="item.lastModifiedDate" class="nowrap contact_owner">
                  <div>
                    <span class="text-muted">Cập nhật:</span>
                    {{ formatDate(item.lastModifiedDate) }}
                  </div>
                  <div v-if="item.lastModifiedByName">
                    <span class="text-muted">Bởi:</span> {{ item.lastModifiedByName }}
                  </div>
                </div>
              </template>
              <template #cell(actions)="{ item }">
                <div class="text-left m-b-5">
                  <b-link
                    :to="`/customer-support/contact/${item.id}`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <b-icon icon="info-square mr-1" aria-hidden="true" /> Chi tiết
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="['PROCESSING', 'NEW'].includes(item.status)">
                  <b-link
                    :to="`/customer-support/contact/${item.id}/edit`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i> Cập nhật
                  </b-link>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import { List } from '@/services/customer-support/contact'
  import { showMess } from '@/config/utils'
  import moment from 'moment'
  import TotalCountCheck from '@/components/cskh/Counts.vue'
  import { List as ListMo } from '@/services/customer-support/merchant-owner'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { List as ListStore } from '@/services/customer-support/store'

  export default {
    components: {
      TotalCountCheck,
    },
    data() {
      return {
        filters: {
          moId: '',
          maId: '',
          storeId: '',
          textSearch: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          staffId: '',
          typeAssign: '',
          status: '',
        },
        queryParam: {
          maId: '',
          maName: '',
        },
        latitude: 0,
        longitude: 0,
        isLoading: true,

        moRoles: [],
        maRoles: [],
        storeRoles: [],

        maSearch: '',
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        totalCount: 0,

        moOptions: [],
        maOptions: [],
        storeOptions: [],

        // config
        dataConfigService: [],
        sourceCreate: Config.sourceCreate,
        localeData: Config.localeData,
        ownershipType: [], // systemConfig.ownershipType,

        listMcType: [
          { id: 0, text: 'Tất cả' },
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_NORMAL', text: 'Merchant thường' },
        ],
        listStatus: [],
        fields: [
          // {
          //   key: 'checkbox',
          //   label: '',
          //   thStyle: 'width: 30px; text-align: center',
          //   sortable: false,
          // },
          {
            key: 'index',
            label: 'STT',
            class: 'text-center',
            thStyle: 'width: 30px; text-align: center',
          },
          {
            key: 'owner',
            label: 'Tài khoản/Cửa hàng',
            sortable: false,
            thStyle: 'min-width: 100px',
            tdClass: 'owner_class',
          },
          // {
          //   key: 'tele',
          //   label: 'Người liên hệ',
          //   sortable: false,
          //   thStyle: 'min-width: 150px, max-width: 200px',
          //   tdClass: 'td_class'
          // },
          {
            key: 'tele_info',
            label: 'Thông tin liên hệ',
            sortable: false,
            thStyle: 'min-width: 100px',
            tdClass: 'td_class',
          },
          {
            key: 'time',
            label: 'Thời gian',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'status',
            label: 'Trạng thái',
            sortable: false,
            thStyle: 'min-width: 100px; max-width: 150px;',
            class: 'text-center ',
          },
          {
            key: 'actions',
            label: 'Thao tác',
            sortable: false,
            class: 'text-center',
            thStyle: 'min-width: 80px',
          },
        ],
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        totals: {
          suspend: 0,
          active: 0,
        },
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],

        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  // showFields: ["id", "ownerName", "email"],
                  limit: 10,
                  page: 1,
                  // queryString,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [`{textSearch} LIKE '''${txtSearch}'''`]
              this.filters.moId && querys.push(`{merchantOwnerId} == '''${this.filters.moId}'''`)

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.listData?.map(item => {
                          return {
                            id: item.id,
                            text: item.accountName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadStore: undefined,
        storeSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `({textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}''')`,
              ]
              this.filters.moId && querys.push(`{merchantOwnerId} == '''${this.filters.moId}'''`)
              this.filters.maId && querys.push(`{mcAccountId} == '''${this.filters.maId}'''`)

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadMa = setTimeout(() => {
                ListStore({
                  showFields: ['id', 'storeName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['storeName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.listData?.map(item => {
                          return {
                            id: item.id,
                            text: item.storeName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
      }
    },
    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    created() {
      const queries = this.$router.currentRoute.query
      if (queries.moId && queries.moName) {
        this.moOptions = [
          {
            id: queries.moId,
            text: queries.moName,
          },
        ]
        this.filters.moId = queries.moId
      }
      if (queries.maId && queries.maName) {
        this.maOptions = [
          {
            id: queries.maId,
            text: queries.maName,
          },
        ]
        this.filters.maId = queries.maId
        this.queryParam.maId = queries.maId
        this.queryParam.maName = queries.maName
      }
      if (queries.storeId && queries.storeName) {
        this.storeOptions = [
          {
            id: queries.storeId,
            text: queries.storeName,
          },
        ]
        this.filters.storeId = queries.storeId
      }
    },
    async mounted() {
      await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_MO_LIST')) {
        await this.buildQuery()
        this.isLoading = false
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getRoleNameMa() {
        return ma => {
          const objStatus = this.maRoles.find(s => s.id === ma)
          return objStatus ? objStatus.text : ma
        }
      },
      getRoleNameMo() {
        return mo => {
          const objStatus = this.moRoles.find(s => s.id === mo)
          return objStatus ? objStatus.text : mo
        }
      },
      getRoleNameStore() {
        return store => {
          const objStatus = this.storeRoles.find(s => s.id === store)
          return objStatus ? objStatus.text : store
        }
      },
      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus?.bgColor ? objStatus.bgColor : 'badge-primary'
        }
      },
      hasCheckeds() {
        return this.dataTable.some(row => row.checked)
      },
    },
    methods: {
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.refreshTable()
      },
      refreshTable() {
        this.buildQuery()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.pagination.page = 1
        this.filters.textSearch = ''
        this.filters.status = ''
        this.filters.moId = ''
        this.filters.maId = ''
        this.filters.storeId = ''
        await this.buildQuery()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.filters.textSearch?.trim()
        textSearch && (conditionsMap.textSearch = textSearch)
        this.filters.status &&
          this.filters.status !== '0' &&
          (conditionsMap.status = this.filters.status)
        this.filters.moId && (conditionsMap.merchantOwnerId = this.filters.moId)
        this.filters.maId && (conditionsMap.merchantAccountId = this.filters.maId)
        this.filters.storeId && (conditionsMap.storeId = this.filters.storeId)

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
      },
      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true
          const searchQuery = {
            count: true,
            countStatus: true,
            showMerchantAccount: true,
            showStaffAssign: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            queryString: this.pagination.queryString,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }
          const res = await List(searchQuery)
          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              return {
                ...el,
                checked: false,
              }
            })
          } else {
            this.dataTable = []
          }
          this.pagination.total = res.data.totalCount
          this.totalCount = res.data.totalCount ?? 0
          if (res.data.listCountStatus) {
            this.totals = res.data.listCountStatus
              .filter(item => item.status)
              .sort((a, b) => a.status.localeCompare(b.status))
              .reduce((acc, item) => {
                const status = acc.find(s => s.status === item.status)
                if (status) {
                  status.count += item.count
                } else {
                  const statusObj = this.listStatus.find(list => list.id == item.status)
                  acc.push({
                    status: statusObj?.text || item.status,
                    status_class: statusObj?.class ?? 'text-primary',
                    count: item.count,
                  })
                }
                return acc
              }, [])
          } else {
            this.totals = []
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      showMapModal(lat, long) {
        this.latitude = lat
        this.longtitude = long
        this.$refs['modal-map'].show()
      },
      async submitForm() {
        this.pagination.page = 1
        this.buildQuery()
      },
      // page
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.maRoles =
                data.data.maContact?.map(item => {
                  return {
                    id: item.code,
                    text: item.name,
                  }
                }) || []
              this.maRoles.unshift({ id: '0', text: 'Tất cả' })
              this.moRoles =
                data.data.moContact?.map(e => {
                  return {
                    id: e.code,
                    text: e.name,
                  }
                }) || []
              this.moRoles.unshift({ id: '0', text: 'Tất cả' })
              this.storeRoles =
                data.data.storeContact?.map(e => {
                  return {
                    id: e.code,
                    text: e.name,
                  }
                }) || []
              this.storeRoles.unshift({ id: '0', text: 'Tất cả' })
              this.listStatus = data.data.contactStatus.map(e => {
                return {
                  ...e,
                  id: e.code,
                  text: e.name,
                  bgColor: e?.code === 'LOCK' ? 'badge-danger' : 'badge-success',
                  class: e?.code === 'LOCK' ? 'text-danger' : 'text-success',
                }
              })
              this.listStatus.unshift({ id: '0', text: 'Tất cả' })
            }
          })
          .catch(error => console.error(error))
      },

      onChangeMo() {
        this.filters.maId = ''
        this.filters.storeId = ''
      },

      onChangeMa() {
        this.filters.storeId = ''
      },
      createContact() {
        this.$router.push(
          `/customer-support/contact/create?maId=${this.queryParam.maId}&maName=${this.queryParam.maName}`
        )
      },
    },
  }
</script>
<style scoped>
  .total_check {
    /* margin: 5px; */
    /* text-align: center; */
    display: flex;
    text-align: center;
  }

  .total_label {
    color: #8a9298;
    font-size: 14px;
  }

  .total_field {
    font-size: 20px;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .time_class {
    min-width: 100px;
    max-width: 150px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .tooltip-class .tooltip-inner {
    background-color: rgb(253, 253, 253);
    color: #319db5;
    text-align: left;
    max-height: 150px;
    max-width: 200px;
    overflow-y: auto;
    border: 1px solid;
  }

  .b-table tbody tr {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.06px;
    text-align: left;
  }

  .b-table thead tr {
    font-size: 13px;
    font-weight: 500;
    line-height: 15.23px;
    text-align: left;
  }

  .title_mo {
    font-size: 20px;
    font-weight: 400;
    line-height: 23.44px;
    text-align: left;
  }

  .list_total {
    font-size: 13px;
    font-weight: 400;
    line-height: 15.23px;
    text-align: left;
  }

  .search_css {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.06px;
    text-align: left;
  }
</style>
<style>
  .address_class {
    min-width: 100px;
    max-width: 220px;
  }

  .owner_class {
    min-width: 120px;
    max-width: 220px;
  }

  .business_type_class {
    min-width: 100px;
    max-width: 180px;
  }

  .status_class {
    min-width: 100px;
    max-width: 120px;
  }

  .contact_owner {
    padding-bottom: 10px;
  }
</style>
